export const formatDate = (dateString: string) => {
  return new Date(
    dateString.split('T')[0] + 'T06:00:00.000Z'
  ).toLocaleDateString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
}
